import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {HotelToursSearchParams} from "../types/interfaces/hotel-tour-search";

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  toggleMap$ = new BehaviorSubject<boolean>(false);

  trackEventInitMap$ = new BehaviorSubject<{}>({});

  private toursLoadedSub = new BehaviorSubject<boolean>(false);
  toursLoaded$ = this.toursLoadedSub.asObservable();

  private showToursLoaderSub = new BehaviorSubject<boolean>(false);
  showToursLoader$ = this.showToursLoaderSub.asObservable();

  private isApplySmartFiltersSub = new BehaviorSubject<boolean>(false);
  isApplySmartFiltersSub$ = this.isApplySmartFiltersSub.asObservable();

  showToursLoader(): void {
    this.showToursLoaderSub.next(true);
  }

  hideToursLoader(): void {
    this.showToursLoaderSub.next(false);
  }

  mobileToursInViewport$ = new Subject<boolean>();

  isOnlyHotelsSearch$ = new Subject<boolean>();

  private hotelViewCountSubject = new BehaviorSubject<any>({});
  hotelViewCount$ = this.hotelViewCountSubject.asObservable();

  setHotelViewCount(hotelId, count) {
    this.hotelViewCountSubject.next({
      hotelId: hotelId,
      count: count
    });
  }

  /* События search-params.component */
  changeTourists$ = new Subject<any>();
  /* Событие смены title в модалке */
  changeModalTitle$ = new Subject<string>();
  /* Событие закрытия модалки */
  isCloseModal$ = new Subject<HTMLElement>();
  /* Событие открытия модалки */
  isOpenModal$ = new Subject<HTMLElement>();

  shortSearchParams$ = new Subject<{}>();
  reloadCalendar$ = new Subject<{}>();
  refreshShortSearchCalendar$ = new Subject<void>();
  openPriceCalendarFromLiner$ = new Subject<void>();
  openCalendarFromEmptyResult$ = new Subject<void>();
  priceCalendarLinerSelection$ = new BehaviorSubject<{ date: string; nights: number } | null>(null);
  priceCalendarAppliedSelection$ = new BehaviorSubject<{ date: string; nights: number } | null>(null);
  resetPriceCalendarLinerSelection$ = new Subject<boolean | void>();
  applyMobilePriceCalendarSelection$ = new Subject<void>();
  priceCalendarModalRangeLoaded$ = new Subject<{ dateFrom: string; dateTo: string }>();

  applySmartFilters() {
    this.isApplySmartFiltersSub.next(true);
  }
}
